import _ from 'underscore';
import {PermissionKey} from './enum/PermissionKey';
import {getAuth} from '../utils/getAuth';
import { UserType } from './enum/UserType';
import { PermissionV2Value } from './enum/PermissionV2Value';

export function checkPermissionFn(key, requiredLevel) {
    const { access, isPartner, company } = getAuth();
    const { permissions } = access || { permissions: {} };

    // // If using payex/ipay88: Bukku Store only supports MYR
    // // If using stripe: Bukku Store supports multiple currencies
    // if (key === PermissionKey.store) {
    //     // if (payment_gateway_provider === 'stripe')
    //     //     return true;
    //     if (company?.currency_code !== 'MYR')
    //         return false;
    // }

    // Periodic-specific Permisison
    if (key === PermissionKey.stock_value) {
        if (company?.inventory_system !== 'periodic')
            return false;
    }

    // Financing Portal specific Permission (only admins are allowed to access it)
    if (key === PermissionKey.financing && access.type !== UserType.admin)
        return false;

    // Partner-specific permission
    if (key === PermissionKey.partners) {
        const canManageBilling = access?.partner_portal_access;
        return isPartner && canManageBilling;
    }

    // Manage-user permission
    if (key === PermissionKey.manage_users)
        return access?.manage_users;

    // Manage-billing permission
    if (key === PermissionKey.manage_billing)
        return access?.manage_billing;

    // If user is admin
    if (access.type === UserType.admin)
        return true;

    let level = permissions[key];

    if (key === PermissionKey.reports_all) {
        return !!Object.keys(permissions)
            .filter(key => key.includes('report'))
            .find(key => PermissionV2Value[permissions[key]] > 0);
    }

    // When No permission defined
    if (level === undefined) {
        // Check for parent key
        if (key.includes('.')) {
            const parentKey = key.split('.')[0];
            level = permissions[parentKey];
        }
        // When no permission is defined => null
        else {
            return null;
        }
    }

    // Evaluating
    const value = PermissionV2Value[level];
    const requiredValue = PermissionV2Value[requiredLevel];

    return requiredValue <= value;
}

/**
 * Check if there are modifiers defined for the keys specified, used specifically for transactions
 * @param {String[] or String} keyOrKeys eg: ['sale', 'sale.invoices'] or 'sale.quote'
 * @param {String[]} requiredModifiers  eg: ['M3']
 * @param {String} matchRule 'some' / 'every'
 * @returns boolean
 */
export function checkModifierFn(keyOrKeys, requiredModifiers, matchRule = 'some') {
    const { access } = getAuth();
    const { permissions } = access || { permissions: {} };

    const keyArray = Array.isArray(keyOrKeys) ? keyOrKeys : [keyOrKeys];

    // get the modifiers associated to the current keys (eg: 'sale' has ['M3'])
    const keyModifiers = keyArray.reduce((acc, key) => {
        const keyModifiers = permissions[`${key}.modifiers`];
        return _.union(acc, keyModifiers || []);
    }, []);
    // console.log('aaa keys keyModifiers requiredModifiers', keyArray, keyModifiers, requiredModifiers);

    if (requiredModifiers === undefined || requiredModifiers === null)
        return true;
    if (matchRule === 'some')
        return requiredModifiers.some(m => keyModifiers.includes(m));
    if (matchRule === 'every')
        return requiredModifiers.every(m => keyModifiers.includes(m));
    return undefined;
}

/**
 * NEW.js
 * inhibitorModifiers = [] (route)
 * keyModifiers = [] (route)
 * requiredModifier = ["M3"] // false [New.js]
 *                           // True (YES Permission)
 *
 * BATCH.js
 * inhibitorModifiers = ["M3"] (route)
 * keyModifiers = ["M3"] (route)
 * requiredModifier = [] // true [Batch.js]
 *                              // False (No Permission)
 *
 *
 *
 */
